import SliderButton from './slider-button.component';
import { BUTTON_DIMENSION, BUTTON_SHADOW_SIZE } from './constants';
export default SliderButton;
export { BUTTON_DIMENSION, BUTTON_SHADOW_SIZE };
